import {Button} from 'antd';
import {CaretDownOutlined, CaretUpOutlined} from '@ant-design/icons';
import React, {Dispatch, SetStateAction} from 'react';
import {
  REDEEM_CLAIMED_OFFER_TYPE,
  REFULFILL_CLAIMED_OFFER_TYPE,
} from 'Utils/constants/genericConstants';
import NestedRowContainer from './NestedRowContainer';

const formatOrderType = (string): string => {
  if (string === REFULFILL_CLAIMED_OFFER_TYPE) {
    return 'Re-fulfill';
  }

  if (string === REDEEM_CLAIMED_OFFER_TYPE) {
    return 'Redeem';
  }

  return string;
};

const OfferRow = (props: {
  row: any;
  backgroundColor: string;
  isParent: boolean;
  onReFulfillClick: (IOrderHistoryAdditionalData, string, boolean) => void;
  onExpandRowClick?: Dispatch<SetStateAction<boolean>>;
  isOpen?: boolean;
}) => {
  const {row} = props;

  return (
    <>
      <tr style={{background: props.backgroundColor}}>
        <td style={{padding: 10}}>
          {!props.isParent && <span>&#x21B3;</span>}
          {row.orderNumber}
        </td>
        <td style={{padding: 10}}>
          <span style={{whiteSpace: 'pre-line'}}>{row.date}</span>
        </td>
        <td style={{padding: 10}}>{row.type}</td>
        <td style={{padding: 10, maxWidth: 50, wordWrap: 'break-word'}}>{row.reedemedBy}</td>
        <td style={{padding: 10}}>{row.status}</td>
        <td style={{padding: 10}}>{formatOrderType(row.orderType)}</td>
        <td style={{padding: 10}}>
          <img
            style={{display: 'block', maxWidth: 60, width: 'auto', height: 'auto'}}
            alt={row.merchantData.altText}
            src={row.merchantData.imageUrl}
          />
        </td>
        <td style={{padding: 10}}>{row.cardCount}</td>
        <td style={{padding: 10}}>${row.cardValue}</td>
        <td style={{padding: 10}}>
          {props.onExpandRowClick && (
            <Button
              type="text"
              size="small"
              aria-label="expand row"
              onClick={() => props.onExpandRowClick && props.onExpandRowClick(!props.isOpen)}
              icon={
                props.isOpen ? (
                  <CaretUpOutlined style={{fontSize: 20}} />
                ) : (
                  <CaretDownOutlined style={{fontSize: 20}} />
                )
              }
            />
          )}
        </td>
      </tr>

      <NestedRowContainer
        row={row}
        backgroundColor={props.backgroundColor}
        onReFulfillClick={props.onReFulfillClick}
        isOpen={props.isOpen}
      />
    </>
  );
};

export default OfferRow;
